import api from "./index";

// ---------------- Sales ----------------
// params: status, intent, source, suburb, agent, matched_only, upcoming_only, q, limit, offset
// Omitting `status` hides dismissed sales; pass status=all to see everything.
export const getGarageSales = (params = {}) =>
  api.get("api/garage-sales/sales/", { params });

export const getGarageSale = (id) =>
  api.get(`api/garage-sales/sales/${id}/`);

// A sale the agent spotted on Gumtree or in the Facebook group and keyed in.
// source is one of 'gumtree' | 'facebook' | 'manual' — the scraped feed's own
// source value is rejected by the API.
export const createGarageSale = (data) =>
  api.post("api/garage-sales/sales/", data);

// Agent-owned fields only: status, assigned_agent, agent_notes.
export const updateGarageSale = (id, data) =>
  api.patch(`api/garage-sales/sales/${id}/`, data);

// Only hand-keyed sales can be deleted; feed rows are dismissed instead.
export const deleteGarageSale = (id) =>
  api.delete(`api/garage-sales/sales/${id}/`);

// Recompute the owners on this street, after correcting the address.
export const rematchGarageSale = (id) =>
  api.post(`api/garage-sales/sales/${id}/rematch/`);

// Register the sale as a Database owner lead (potential seller) for the agent to
// call/door-knock. Idempotent server-side. Response: { created, record_id, sale }.
export const registerGarageSaleLead = (id) =>
  api.post(`api/garage-sales/sales/${id}/register-lead/`);

export const getGarageSaleStats = (params = {}) =>
  api.get("api/garage-sales/stats/", { params });

// ---------------- Watch areas (admin) ----------------
export const getWatchAreas = () =>
  api.get("api/garage-sales/watch-areas/");

export const createWatchArea = (data) =>
  api.post("api/garage-sales/watch-areas/", data);

export const updateWatchArea = (id, data) =>
  api.patch(`api/garage-sales/watch-areas/${id}/`, data);

export const deleteWatchArea = (id) =>
  api.delete(`api/garage-sales/watch-areas/${id}/`);

// Force a pull now, however recently the feed ran. Admin only.
export const syncGarageSales = () =>
  api.post("api/garage-sales/sync/");

// Called by the page when it opens, so nobody has to press Sync feed. The server
// decides whether anything actually runs: it syncs only when the feed has gone
// stale, and only one sync runs at a time no matter how many agents are looking.
// Response: { started, reason, queued, feed: { last_synced_at, stale, syncing } }
export const autoSyncGarageSales = () =>
  api.post("api/garage-sales/auto-sync/");

// The two sources that cannot be polled: Gumtree answers an automated request
// with a 403, and the Facebook group is private. Agents open these, spot a sale
// and add it by hand — which is why "Add a sale" exists.
export const MANUAL_SOURCES = [
  {
    key: "gumtree",
    label: "Gumtree garage sales (VIC)",
    url: "https://www.gumtree.com.au/s-garage-sale/vic/c18486l3008844",
  },
  {
    key: "facebook",
    label: "Melbourne garage sales group",
    url: "https://www.facebook.com/groups/3010647742496675/",
  },
];
